import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';

import { MenuItems } from '../../../Core/menu/menu-items/menu-items';
import { AuthService } from 'src/app/Services/auth.service';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'embryo-Menu',
  templateUrl: './Menu.component.html',
  styleUrls: ['./Menu.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuComponent implements OnInit {

   expanded       : boolean;
   menuItemsFiltered = [];

   constructor(public menuItems: MenuItems,public router: Router, public translate: TranslateService, private auth : AuthService, private loadingService: LoadingBarService) {
   }

   ngOnInit() {
     this.auth.checkIsUserAdmin.subscribe(resp => {
      let items = [...this.menuItems.getMainMenu()];
       if (resp === "No") {
         items.splice(items.findIndex(it => it.state === 'admin-panel'), 1);
         this.menuItemsFiltered = [...items];
       } else if (resp === 'Yes') {
         this.menuItemsFiltered = [...items];
       } else {
         items.splice(items.findIndex(it => it.state === 'admin-panel'), 1);
         this.menuItemsFiltered = [...items];
       }
     })
   }

   public onItemSelected(item: any) {
      if (item.children && item.children.length) {
         this.expanded = !this.expanded;
      }
   }


   public redirectTo(subchildState){
      this.router.navigate([subchildState.state],{ queryParams:{ category: subchildState.queryState }});
   }

}
